<template>
  <layout>
    <div id="vacancy-page">
      <!-- Header -->
      <header class="header text-white py-2">
        <div class="container text-center">
          <div class="row">
            <div class="col-md-8 mx-auto pt-10 pb-9">
              <h1 class="display-41 animated fadeInDown delay-1s slow">
                {{ message }}
              </h1>
            </div>
          </div>

          <div class="partner partner-sm">
            <search-bar class="animated fadeInUp delay-1s slow" />
          </div>
        </div>
      </header><!-- /.header -->

      <!-- Main Content -->
      <main class="main-content">
        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | List Vacancy
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section class="section py-10">
          <list-vacancy />
        </section>
      </main><!-- /.main-content -->
    </div>
  </layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Layout from './shared/layout.vue';
import SearchBar from '../components/search-bar.vue';
import ListVacancy from '../components/list-vacancy.vue';

export default {
  name: 'VacancyPage',
  components: {
    Layout,
    SearchBar,
    ListVacancy,
  },
  props: {
    currentUserProp: {
      type: Object,
      required: true,
    },
    currentUserTypeProp: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      message: 'Todas as vagas de emprego disponíveis',
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
  },
  mounted() {
    const currentUser = { ...this.currentUserProp };
    const currentUserType = this.currentUserTypeProp;

    this.$store.commit('UserStore/SET_CURRENT_USER', currentUser);
    this.$store.commit('UserStore/SET_CURRENT_USER_TYPE', currentUserType);
  },
};
</script>

<style lang="scss" scoped>
  @use '../assets/stylesheet/variables.scss' as *;
  #vacancy-page {
    header.header {
      background-color: $abler_primary;

      #search-bar {
        position: absolute;
        bottom: -23%;

        @media screen and (max-width: 576px) {
          bottom: -33%;
        }
      }
    }
  }
</style>
